import { statement as apis } from '@/api/finance'
// 财务报表
const listConfig = [
    { title: '发车时间', key: 'carNo' },
    { title: '线路', key: 'carType' },
    { title: '车号', key: 'carGno' },
    { title: '车型', key: 'remark' },
    { title: '运单状态', key: 'carNo' },
    { title: '到车运费', key: 'carType' },
    { title: '到车油卡', key: 'carGno' },
    { title: '结算方式', key: 'remark' },
    { title: '押金', key: 'carNo' },
    { title: '结算金额', key: 'carType' },
    { title: '发起人', key: 'carGno' },
    { title: '发起时间', key: 'remark' }
]

function createSearch(list) {
    const searchConfig = [
        { title: '发车时间', value: '', key: 'deliveryTime1', type: 'date' },
        { title: '线路', value: '', key: 'deliveryTime2', type: 'select', list },
        { title: '车牌号', value: '', key: 'deliveryTime3', type: 'input' },
        { title: '提审时间', value: '', key: 'deliveryTime4', type: 'date' },
        { title: '姓名', value: '', key: 'deliveryTime5', type: 'input' },
        { title: '电话', value: '', key: 'deliveryTime6', type: 'input' },
    ]
    return searchConfig
}

const btnConfig = [
    { bg: '#19458C', title: '提 交', key: 'submit', role: 'TJ' },
    { bg: '#EA5B24', title: '驳 回', key: 'reject', role: 'BH' }
]

function fromConfig() {
    return [
        { title: '车牌号', value: '', key: 'carNo', type: 'input' },
        { title: '车型', value: '', key: 'carType', type: 'input' },
        { title: '挂车号', value: '', key: 'carGno', type: 'input' },
        { title: '备注', value: '', key: 'remark', type: 'input' }
    ]
}

function createSubmit() {
    const submitConfig = [
        { column: '提 交' },
        { title: '保险', value: '', key: 'deliveryTime1', type: 'input', span: 6 },
        { title: '罚款', value: '', key: 'deliveryTime2', type: 'input', span: 6 },
        { title: '补助', value: '', key: 'deliveryTime3', type: 'input', span: 6 },
        { title: '审核备注', value: '', key: 'deliveryTime4', type: 'input', span: 6 },
    ]
    return submitConfig;
}

function createReject() {
    const rejectConfig = [
        { column: '驳 回' },
        { title: '审批备注', value: '', key: 'deliveryTime1', type: 'textarea', span: 24 },
    ]
    return rejectConfig;
}


export default function config() {
    return {
        listConfig,
        btnConfig,
        fromConfig,
        createSearch,
        createSubmit,
        createReject,
        apis
    }
}
